import { autoinject, LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';
import { ToastService } from './toast-service';

const logger: Logger = LogManager.getLogger('error-service');

@autoinject
export class ErrorService {
  public constructor(private toastService: ToastService) {}

  public handleError(err: any) {
    logger.error('An error occurred', err);
    let message = 'An unexpected error occurred';
    if (err instanceof Error) {
      message = err.message;
    } else if ('detail' in err) {
      message = err.detail;
    } else if (typeof err === 'string') {
      message = err;
    }

    this.toastService.showError(null, 'general.error', message);
  }
}
